<div class="replace-matcard">
  <h1>{{company?.title}}</h1>
  <button mat-raised-button class="color" [routerLink]="['/company/edit/0']">
    <mat-icon class="add">add_box</mat-icon>{{company?.addButton}}
  </button>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource">

      <!-- Name Column -->
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{company?.col1Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          {{element?.name}}
        </td>
      </ng-container>

      <!-- Country Column -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef class="centerContent"> <b>{{company?.col2Titel}}</b> </th>
        <td mat-cell *matCellDef="let element" class="tableField">{{element?.country}}</td>
      </ng-container>

      <!-- Contact Column -->
      <ng-container matColumnDef="contactName">
        <th mat-header-cell *matHeaderCellDef class="centerContent"> <b>{{company?.col3Titel}}</b> </th>
        <td mat-cell *matCellDef="let element" class="tableField">{{element?.contactFirstName}}
          {{element?.contactLastName}}</td>
      </ng-container>

      <!-- ActiveState Column -->
      <ng-container matColumnDef="activeState">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{company?.col4Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{getIsActiveText(element.isBusinessActive)}}</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="companyActions">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{company?.col5Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <mat-icon class="openCell" title="{{company?.action1}}" (click)="openCellEdit(element.id)">edit</mat-icon>
          <mat-icon title="{{company?.action4}}" class="lockOpen" *ngIf="element.isBusinessActive == false"
            (click)="activateCompany(element.id)">lock_open</mat-icon>
          <mat-icon title="{{company?.action3}}" class="lock" *ngIf="element.isBusinessActive == true"
            (click)="deactivateCompany(element.id)">lock</mat-icon>
          <mat-icon class="delete" title="{{company?.action2}}" (click)="showDeleteDialog(element.id)">cancel</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row;let element; columns: displayedColumns;" class="table-row-effect"></tr>
    </table>
  </div>
</div>
<hr class="line">